/**
 * Tiện ích cuộn trang — lên đầu, khôi phục vị trí, scroll tới element có offset.
 */

/**
 * Cuộn window về đầu trang.
 * @param {ScrollBehavior} [behavior='auto']
 */
export const scrollToPageTop = (behavior = 'auto') => {
  window.scrollTo({ top: 0, left: 0, behavior });
};

/**
 * Khôi phục vị trí scroll sau double rAF (tránh layout shift).
 * @param {number} top
 * @param {ScrollBehavior} [behavior='auto']
 */
export const restorePageScroll = (top, behavior = 'auto') => {
  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(() => {
      window.scrollTo({ top, left: 0, behavior });
    });
  });
};

/**
 * Cuộn tới element với offset cố định (sticky header).
 * @param {HTMLElement|null} element
 * @param {number} [offset=148]
 * @param {ScrollBehavior} [behavior='smooth']
 */
export const scrollElementIntoViewWithOffset = (element, offset = 148, behavior = 'smooth') => {
  if (!element) {
    return;
  }

  const elementTop = element.getBoundingClientRect().top + window.scrollY;

  window.scrollTo({
    top: Math.max(0, elementTop - offset - 12),
    left: 0,
    behavior,
  });
};
